"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalDirectDebitHeadsUpWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var DirectDebitFunctions_1 = require("../annual/motor/directDebit/DirectDebitFunctions");
var journey_services_1 = require("@athena-portal/journey-services");
var RenewalDirectDebitHeadsUpWidget = /** @class */ (function (_super) {
    __extends(RenewalDirectDebitHeadsUpWidget, _super);
    function RenewalDirectDebitHeadsUpWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    RenewalDirectDebitHeadsUpWidget.prototype.componentDidMount = function () {
    };
    RenewalDirectDebitHeadsUpWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: this.renderContent() }));
    };
    RenewalDirectDebitHeadsUpWidget.prototype.renderContent = function () {
        var interaction = this.props.interaction;
        var paymentDate = (0, DirectDebitFunctions_1.getFirstInstalmentDueDate)(interaction).format("Do MMMM YYYY");
        var url = this.getChangePaymentDetailsPageUrl();
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "info-button-panel font-weight-light d-flex banner info-banner", children: [(0, jsx_runtime_1.jsx)("div", { className: "info-button col-lg-2" }), (0, jsx_runtime_1.jsxs)("p", { className: "banner-text mb-0", children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "Heads up - " }), "Please check your Direct Debit details and ", (0, jsx_runtime_1.jsx)("a", { href: "".concat(url), className: "buttonLink", id: "changePaymentDetailsLink", children: " edit them " }), " if you want to.", (0, jsx_runtime_1.jsx)("br", {}), "We'll take the first installment on the ", paymentDate, "."] })] }) }));
    };
    RenewalDirectDebitHeadsUpWidget.prototype.getChangePaymentDetailsPageUrl = function () {
        var changePaymentDetailsPageUrl = this.getSetting("changePaymentDetailsPageUrl", undefined);
        if (changePaymentDetailsPageUrl) {
            return journey_services_1.ExpressionEvaluator.renderTemplate(changePaymentDetailsPageUrl, this.props.interaction, true);
        }
        return "/";
    };
    RenewalDirectDebitHeadsUpWidget = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], RenewalDirectDebitHeadsUpWidget);
    return RenewalDirectDebitHeadsUpWidget;
}(plugin_journey_1.WidgetBase));
exports.RenewalDirectDebitHeadsUpWidget = RenewalDirectDebitHeadsUpWidget;
//# sourceMappingURL=RenewalDirectDebitHeadsUpWidget.js.map